import cx from 'classnames';
import {
  Service as OrganicService,
  TexturedCircle,
} from 'themes/organic/components';
import { ContentContainer } from 'themes/organic/components/ContentContainer';

import { Heading } from 'components/Heading';
import { NoServices } from 'components/NoServices/NoServices';

import {
  TServiceProps,
  useServicesPage,
} from 'hooks/page/services/useServicesPage';

import s from './OrganicServices.module.css';

const Service = ({
  onClick,
  listView,
  selected,
  disabled,
  service,
  serviceProvider,
  selectedOption,
}: TServiceProps) => {
  return (
    <OrganicService
      className={s.service}
      service={service}
      ctaText="select"
      ctaSelectedText="unselect"
      onClick={onClick}
      listView={listView}
      selected={selected}
      disabled={disabled}
      serviceProvider={serviceProvider}
      selectedOption={selectedOption}
    />
  );
};

const OrganicServices = () => {
  const {
    services,
    headingText,
    renderSelectors,
    renderBookingHeader,
    renderAutoBookingErrorModal,
    renderOfflineBookingModal,
    renderServiceProviderChangeModal,
    renderServiceOptionsModal,
    renderMaxAppointmentsWarning,
    renderService,
    isListView,
  } = useServicesPage();

  return (
    <>
      {renderBookingHeader()}
      <section className={s.root}>
        <ContentContainer>
          <TexturedCircle className={s.texturedCircle} />
          <div className={s.content}>
            <Heading as="h1" variant="large">
              Services
            </Heading>
            {services.length > 0 ? (
              <>
                <section className={s.subtitleWrapper}>
                  {headingText && (
                    <Heading as="h2" className={s.headingText}>
                      {headingText}
                    </Heading>
                  )}
                  <div className={s.dropdownWrapper}>{renderSelectors()}</div>
                </section>

                <div
                  className={cx(s.serviceList, {
                    [s.listView]: isListView,
                  })}
                >
                  {services.map((service) => (
                    <article className={s.serviceItem} key={service.guid}>
                      {renderService(service, Service)}
                    </article>
                  ))}
                </div>
              </>
            ) : (
              <NoServices />
            )}
          </div>
        </ContentContainer>
      </section>
      {renderAutoBookingErrorModal()}
      {renderOfflineBookingModal()}
      {renderServiceProviderChangeModal()}
      {renderMaxAppointmentsWarning()}
      {renderServiceOptionsModal()}
    </>
  );
};

export { OrganicServices };
